import { Component } from '@angular/core';

@Component({
  selector: 'app-agentic-explanation-panel',
  templateUrl: './explanation-panel.component.html',
  styleUrls: ['./explanation-panel.component.css'],
})
export class ExplanationPanelComponent {}
